type FreestarAdSlotModule = typeof import('@freestar/pubfig-adslot-react-component');

let freestarAdSlotPromise: Promise<FreestarAdSlotModule> | null = null;

export const loadFreestarAdSlot = (): Promise<FreestarAdSlotModule> => {
  if (!freestarAdSlotPromise) {
    freestarAdSlotPromise = import('@freestar/pubfig-adslot-react-component');
  }
  return freestarAdSlotPromise;
};
